import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import { Flex, NoResults, Panel } from 'mailup-web-components'

import Divider from 'Components/Divider'

import Counter from 'Pages/GroupsList/components/Counter'
import Pager from 'Pages/GroupsList/components/Pager'
import ResultsTable from 'Pages/GroupsList/components/ResultsTable'

import { paginationState } from 'Pages/GroupsList/recoil/state/state'
import BatchActions from './BatchActions'

const Results: FC = () => {
  const intl = useIntl()

  const { totalItems, loading } = useRecoilValue(paginationState)

  return (
    <Panel data-mu-test="panel-search" margin="0">
      <Flex flexDirection="column" gap="16px">
        <Flex alignItems="center" justifyContent="space-between">
          <Counter />
        </Flex>
        <Divider />
        {!loading && totalItems === 0 ? (
          <NoResults margin="0">
            {intl.formatMessage({ id: 'Load.Common.NoResultChosen' })}
          </NoResults>
        ) : (
          <>
            <BatchActions />
            <ResultsTable />
            <Pager />
          </>
        )}
      </Flex>
    </Panel>
  )
}

export default Results
